/**
 * The tracker's own AI optimization (Voluum's traffic distribution AI) in the
 * Standard editor. Tres Commas ignores automationConfiguration, so its cards
 * are hidden and its flags never lock a weight there. Render-only: the flow
 * payload keeps whatever the tracker returned.
 * For Media Devoted | Created By Ciro Autiero
 */

import { usePreviewMode } from '@/features/flow-optimizer/components/preview/PreviewIndexContext';

import { useDrawerProfile } from './flow-tracker-context';

/** True when the tracker on screen has its own AI optimization. */
export function useTrackerAi(): boolean {
  return useDrawerProfile().trackerAi;
}

/**
 * Hide the tracker-AI controls: while TrafficPulse Optimisation (preview) is
 * active they are auto-managed, and a tracker without AI never has them.
 */
export function useTrackerAiHidden(): boolean {
  const previewMode = usePreviewMode();
  const { trackerAi } = useDrawerProfile();
  return previewMode || !trackerAi;
}
